import React, { useState, ButtonHTMLAttributes, ReactNode, CSSProperties } from 'react';

export type IconButtonVariant = 'ghost' | 'tinted';

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> & {
  icon: ReactNode;
  label: string;
  size?: number;
  active?: boolean;
  variant?: IconButtonVariant;
  style?: CSSProperties;
};

export function IconButton({
  icon,
  label,
  size = 36,
  active,
  variant = 'ghost',
  style,
  ...rest
}: IconButtonProps) {
  const [hover, setHover] = useState(false);
  const bg = active
    ? 'var(--bg-fill-2)'
    : hover
      ? 'var(--bg-fill-1)'
      : variant === 'tinted' ? 'var(--bg-fill-1)' : 'transparent';

  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label={label}
      title={label}
      style={{
        width: size, height: size,
        borderRadius: 'var(--r-md)',
        background: bg,
        color: active ? 'var(--accent)' : 'var(--fg-secondary)',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out)',
        ...style,
      }}
      {...rest}
    >
      {icon}
    </button>
  );
}

export default IconButton;
